import React from 'react';
import { Fragment, useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next/hooks';

import Button from '../../Button/Button';
import GroupInvitationQRCode from './GroupInvitationQRCode';
// import EditGroupModal from '../EditGroup/EditGroupModal';
import Loader from '../../Loader/Loader';

import { useStore } from '../../../hook-store/store';
import { 
  addGroupInvitation, 
} from '../../../util/group/group-invitation';
import { email } from '../../../util/validators';

import { SOCKET_GROUP_URL } from '../../../App';

import { marks } from '../../../images/marks';
import '../../../pages/GroupTalk/GroupTalk.css';
import './GroupInvitation.css';

const GroupInvitationForm = (props) => {
  // console.log('grouplistItem.js props', props);

  const { 
    group,
    usersData,
    userId,
    isLoading,

    showInvitationModal,
    showInvitationModalHandler,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { groupInvitationData } = store.groupStore;

  const [inviteFormInput, setInviteFormInput] = useState({
    email: '',
    groupRoomId: group.groupRoomId,
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [showInvitationForm, setShowInvitationForm] = useState(false);
  const [showAboutInvitation, setShowAboutInvitation] = useState(false);
  const [showConfrim, setShowConfirm] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);

  const setFormInputHandler = (event, key) => {
    setErrorMessage('');
    setShowConfirm(false);

    const inputValue = event.target.value;

    setInviteFormInput({
      ...inviteFormInput,
      [`${key}`]: inputValue,
    });
  }


  const addGroupInvitationHandler = async (groupRoomId, emailInput) => {
    try {
      if (!email(emailInput)) {
        setErrorMessage('enter valid email address');
        return;
      } 

      const isInInvitingList = groupInvitationData.invitingUsers.find(element => {
        return element.email === emailInput;
      });

      if (isInInvitingList) {
        setErrorMessage('user is already in inviting list');
        return;
      }

      const isInAcceptList = groupInvitationData.inviteAcceptUsers.find(element => {
        return element.email === emailInput;
      });

      if (isInAcceptList) {
        setErrorMessage('user is already in accept list');
        return;
      }

      setIsDataLoading(true);

      const resData = await addGroupInvitation(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        groupRoomId,
        emailInput,
      );

      if (resData.data?.invitingUsers) {
        dispatch('SET_GROUPINVITATIONDATA', {
          ...groupInvitationData,
          invitingUsers: resData.data.invitingUsers,
        });

        dispatch('SHOW_NOTIFICATION', {
          // status: 'pending',
          //   title: '',
          message: 'add success',
        });
  
        setTimeout(() => {
          dispatch('CLEAR_NOTIFICATION');
        },1000*5);

        setShowConfirm(false);
      }

      setIsDataLoading(false);

    } catch(err) {
      console.log(err);
      setIsDataLoading(false);
      setErrorMessage('Invitation failed');
      throw err;
    }
  };





  const groupInvitationFormBody = (
    <div>
      <div className='groupInvitationRow'>
        <strong className='groupInivitationTitle'
          onClick={() => { 
            setShowInvitationForm(!showInvitationForm);
          }}
        >
          {t('groupTalk.text54', 'Invite user to this group')}
          {' '}{marks.triangleDown}{' '}
        </strong>
        <span
            onClick={() => { 
              // setShowAboutInvitation(!showAboutInvitation);
              setShowInvitationForm(!showInvitationForm);
            }}
          >
            {marks.questionCircleMark}
          </span>
        {' '}
      </div>
      {showInvitationForm && (
        <div className='groupInvitationRow'>
          <div className='groupInvitationMessage'>
            <div>
              {/* {t('groupTalk.text55', 'Group creator can invite other users to the group. Email address of the user is required.')} */}
              {t('groupTalk.text93', 'Group creator can invite other users to the group.')}
              <br/> 
              {t('groupTalk.text94', 'Scanning QR code by other users, or Email address of other users is required.')}
              {/* {t('groupTalk.text56', 'Please confirm the user have account using the email address.')} */}
            </div>
            <br/>
          </div>
        </div>
      )}



      {/* {JSON.stringify(group)} */}
      {showInvitationForm && (
        <div className='groupInvitationMessage'>
          <div>
            <strong>QR code</strong>
          </div>
          <div className='groupInvitationRow'>
            <GroupInvitationQRCode 
              group={group}
            />
          </div>
          <div className='groupInvitationRow'>
            <div>
              <strong>
                {t('groupTalk.text59', 'Email address')}
              </strong>
            </div>
            <div className='groupInvitationRow'>
              {t('groupTalk.text95', 'When invite other users by email, please confirm the user have account using the email address.')}
              <br/>
              <br/>
              {t('groupTalk.text57', "After successful invitation, invitation meesage will be shown on this page in user's device.")}
              {' '}
              {t('groupTalk.text58', 'To become the member of this group, the user need to accept your invitation.')}
            </div>

            <div>
              <label>
                {t('groupTalk.text59', 'Email address')}
              </label>
            </div>
            <input className='groupInvitationEmailInput'
              type='text'
              placeholder='enter email address of user for invitation'
              onChange={(event) => {
                setFormInputHandler(event, 'email');
              }}
            />
          </div>

          <div className='groupInvitationRow'>
            <Button mode="raised" design="" type="submit" 
              onClick={() => {
                setShowConfirm(true);
              }}
              // disabled={}
              loading={isLoading || isDataLoading}
            >
              {t('groupTalk.text60', 'Invite user')}
            </Button>
          </div>
          {showConfrim && (
            <div>
              <div className='groupInvitationRow'>
                {t('groupTalk.text60', 'Invite user')} 
                {' '}{inviteFormInput.email}?
              </div>
              <div className='groupInvitationButtons'>
                <Button mode="" design="" type="submit" 
                    onClick={() => {
                      setShowConfirm(false);
                    }}
                    // disabled={}
                    loading={isLoading || isDataLoading}
                  >
                    {t('groupTalk.text51', 'Cancel')}
                </Button>
                <Button mode="raised" design="" type="submit" 
                  onClick={() => {
                    addGroupInvitationHandler(
                      inviteFormInput.groupRoomId,
                      inviteFormInput.email,
                    )
                  }}
                  // disabled={}
                  loading={isLoading || isDataLoading}
                >
                  {t('groupTalk.text60', 'Invite User')}
                </Button>
              </div>
            </div>
          )}

          <div className='groupInvitationRow'>
            {errorMessage}
          </div>

          {(isLoading || isDataLoading) && (
            <Loader />
          )}

          <div className="groupTalk__createResult">
            {/* {deleteGroupResult} */}
          </div>
        </div>
      )}
      
    </div>
  );

  return (
    <Fragment>
      <div>
        {groupInvitationFormBody}
      </div>
    </Fragment>
  );
}

export default GroupInvitationForm;